var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C8.2 2 2 8.2 2 16s6.4 14 14 14 14-6.4 14-14S23.8 2 16 2m7.8 11.4L15.2 22c-.8.8-2 .8-2.8 0L8 17.6c-.8-.8-.8-2 0-2.8s2-.8 2.8 0l3 3 7.2-7.2c.8-.8 2-.8 2.8 0s.8 2 0 2.8"
  })));
};
export default SvgCheckCircle;